import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { capitalizeFirstLetter } from '../pages/attendee/detail/components/utils';

export default class ModerationActions extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId, transitionId }) {
        if (!transitionId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transition_actions`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transitions/${transitionId}/transition_actions`;
    }

    activate({ organizationId, flowId }) {
        let url = `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transition_actions/${this.pk}/activate`;

        return fetcher.post(url);
    }

    deactivate({ organizationId, flowId }) {
        let url = `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transition_actions/${this.pk}/deactivate`;

        return fetcher.post(url);
    }

    get status_color() {
        return this.object.active ? 'green' : 'gray';
    }

    get name() {
        return capitalizeFirstLetter(this.object.name);
    }

    get mode() {
        return this.object.optional_value === null ? 'is_mandatory' : 'is_optional';
    }

    get status() {
        return this.object.active ? 'active' : 'inactive';
    }

    toOption() {
        return {
            key: this.id,
            text: this.name,
            value: this.id,
            item: this.object
        };
    }
}
